import FeedbackMessage from './FeedbackMessage';

export default FeedbackMessage;
